/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import { af, de, enGB, enUS, es, frCA, fr, it, ja, ptBR, ru, zhCN} from 'date-fns/locale'
import {format} from "date-fns";
let datefnsLocales = {
    'af-za': af,
    'de-de': de,
    'en-dev': enUS,
    'en-gb': enGB,
    'en-us': enUS,
    'es-419': es,
    'es-es': es,
    'fr-ca': frCA,
    'fr-fr': fr,
    'it-it': it,
    'ja-jp': ja,
    'pt-br': ptBR,
    'ru-ru': ru,
    'zh-cn': zhCN,
}
const locale  = document.querySelector('meta[name="locale"]').content;
window.datefnsLocale = datefnsLocales[locale]
$(function() {
    /// This converts all locale dates
    var dates = document.getElementsByClassName("js-localised-date-tag");
    for (var i = 0; i < dates.length; i++) {
        var date = new Date(dates[i].getAttribute('data-iso8601date'))
        console.log(date)
        dates[i].innerText = format(date,'PPpp', {locale: window.datefnsLocale})
    }
});
